module.exports = __webpack_public_path__ + "static/media/wf.9b79d329.svg";